module.exports = __webpack_public_path__ + "img/25.64ea5567.svg";